<template>
  <div class="regulation-table">
    <div>
      <v-client-table
        id="regulations"
        ref="regulations"
        name="regulations"
        :data="regulationTable"
        :columns="columns"
        :options="options"
      >
        <div slot="afterFilter">
          <span><i class="fas fa-search fa-2x" /></span>
        </div>
        <div
          slot="proposed_reg"
          slot-scope="{row}"
          style="display: flex; align-items: top;"
        >
          <div>
            <a
              :href="regulationsUrl+row.reg_link"
            >
              {{ row.proposed_reg }}
            </a>
          </div>
          <div class="tooltip-icon">
            <i
              v-clipboard:copy="encodeURI(regulationsUrl+row.reg_link)"
              v-tooltip="{ content: 'Copy link to PDF', trigger: 'hover' }"
              class="fas fa-copy"
            />
          </div>
        </div>
        <div
          slot="hearing_report"
          slot-scope="{row}"
        >
          <a
            :href="regulationsUrl+row.hearing_report"
          >
            {{ row.hearing_report }}
          </a>
        </div>
        <div
          slot="law"
          slot-scope="{row}"
          style="display: flex; align-items: top;"
        >
          <div>
            {{ row.law ? 'Yes' : 'No' }}
          </div>
        </div>
        <div
          slot="supporting_documents"
          slot-scope="{row}"
        >
          <a
            v-for="document in row.supporting_documents"
            :key="document.key"
            :href="regulationsUrl+document"
            class="block"
            v-html="document"
          />
        </div>
        
      </v-client-table>
    </div>
  </div>
</template>

<script>
window.moment = require('moment');

export default {
  name: 'RegulationTable',
  props: {
    regulationTable: {
      type: Array,
      default: () => {
        return [];
      },
    },
    pageInfo: {
      type: Object,
      default: () => {
        return [];
      },
    },
  },
  data: function() {
    return {
      regulationsUrl: process.env.VUE_APP_REGULATIONS_URL,
      // columns: [ "filing_date", "department", "proposed_reg", "hearing_request", "hearing_date", "hearing_report", "final_reg", "law", "supporting_documents" ],
      columns: [ "filing_date", "department", "proposed_reg", "hearing_request", "hearing_date", "hearing_report", "final_reg", "law", "supporting_documents" ],
      options: {
        addSortedClassToCells: true,
        dateColumns: [ 'filing_date', 'hearing_date' ],
        toMomentFormat: 'MM/DD/YYYY',
        dateFormat: 'MM/DD/YYYY',
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down',
        },
        texts: {
          filterPlaceholder: "Search keywords",
        },
        perPage: 10,
        perPageValues: [],
        pagination: {
          chunk : 3,
        },
        headings: {
          department: 'Department or agency',
          proposed_reg: 'Proposed regulation',
          hearing_request: 'Hearing requested?',
          hearing_report: 'Hearing report filed',
          final_reg: 'Final regulation',
          law: 'Became law',
        },
      },
    };
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.tooltip-icon {
  width: 42px;
  padding: 0 10px;
  color: #0f4d90;
  &:hover {
    color:#444444;
  }
}
</style>